import { FC, memo, useState, useCallback } from "react";
import cx from "classnames";

import styles from "./Button.module.scss";

// Inner imports
import type { ButtonProps } from "./types";
import { useButtonTypeClassName } from "./hooks";
import { handleButtonColor, handleEnterClick } from "./utils";

export const Button: FC<ButtonProps> = memo(
  ({
    type = "button",
    content,
    disabled,
    className = "",
    buttonType = "primary",
    buttonSize = "medium",
    buttonStyle = "filled",
    shouldPreventEnter = false,
    ...props
  }) => {
    const [fontColor, setFontColor] = useState<string>("");

    const buttonTypeClassName = useButtonTypeClassName(buttonType, buttonStyle);

    const refCallback = useCallback(
      (element: HTMLButtonElement | null): void => {
        handleButtonColor({
          element,
          disabled,
          buttonType,
          buttonStyle,
          updateHandler: setFontColor,
        });

        handleEnterClick({ element, shouldPreventEnter });
      },
      [buttonStyle, buttonType, disabled, shouldPreventEnter],
    );

    return (
      <button
        {...props}
        type={type}
        ref={refCallback}
        className={cx(
          className,
          styles.button,
          styles[`button-${buttonSize}`],
          styles[`button-${buttonStyle}`],
          styles[buttonTypeClassName],
        )}
        style={{
          ...(disabled ? {} : { color: fontColor }),
          ...props.style,
        }}
        disabled={disabled}
      >
        {content || props.children}
      </button>
    );
  },
);
